import { Box } from '@chakra-ui/react'
import React from 'react'
import { MainGame } from './Durgesh_Folder/Pages/MainGame'

const DisplayData = () => {
  return (
    <Box>
       <MainGame />
    </Box>
  )
}

export {DisplayData}
